/**
 * Created by ivan on 11.04.18.
 */

const OrdersToolbarItem = function () {
    ToolbarItem.call(this, ToolbarItem.ORDERS);

    this.enable();
};

OrdersToolbarItem.prototype = Object.create(ToolbarItem.prototype);
OrdersToolbarItem.prototype.constructor = OrdersToolbarItem;

OrdersToolbarItem.prototype.resetState = function () {
    // Harvested can be created at chat scene to accept gift and currentGame will be undefined
    const ready = Map2dLocation.currentLocation && (Map2d.currentMap.customers.findCanCook() || Map2d.currentMap.customers.findReady());

    if (ready) {
        this.mark();
    } else {
        this.unmark();
    }
};

OrdersToolbarItem.prototype.isVisible = function () {
    return ["main"].indexOf(cleverapps.meta.selectedLocationId()) !== -1;
};

OrdersToolbarItem.prototype.onClick = function () {
    cleverapps.focusManager.display({
        focus: "OrdersIconClicked",
        stack: cleverapps.tutorial.checkConditions({ tutorial: TutorialScenario.BASIC_TUTORIAL_NAME, toolbarItem: ToolbarItem.ORDERS.type }),
        action: function (f) {
            new OrdersWindow();
            cleverapps.focusManager.onceNoWindowsListener = f;
        }
    });
};